import { proxy } from 'valtio';
import { z } from 'zod';
import { leasingApi } from '@/api';
import { ClientConfig } from '@/client-config';

export const authStateSchema = z.object({
  isMitIDAuthenticated: z.boolean(),
  isFFAuthenticated: z.boolean(),
});

export type AuthState = z.infer<typeof authStateSchema>;

export const authState = proxy<AuthState>({
  isMitIDAuthenticated: false,
  isFFAuthenticated: false,
});

export function login(loginUrl: string) {
  window.location.replace(loginUrl);
}

export function logout() {
  window.location.href = ClientConfig.logoutUrl;
}

export async function GetAuthenticationStatus() {
  try {
    const body = await leasingApi.getApiV1AuthenticateGetAuthenticationStatus();
    authState.isMitIDAuthenticated = body.isMitIDAuthenticated || false;
    authState.isFFAuthenticated = body.isFFAuthenticated || false;
  } catch (error) {
    authState.isMitIDAuthenticated = false;
    authState.isFFAuthenticated = false;
    console.error('failed to verify authentication status:', error);
  }
  return authState;
}
